import React from 'react';
import PageShell from './page-shell';
import type {PageShellProps} from './types';

/**
 * List page preset — list-oriented content skeleton defaults.
 */
const ListPageShell = (props: PageShellProps): React.ReactElement => (
    <PageShell contentSkeletonVariant="list" {...props}/>
);

export default ListPageShell;
